import React from "react";
import createClass from "create-react-class";
import DownloadButton from "./DownloadButton.react";
import PropTypes from "prop-types";
import ScreenSize from "../../utils/ScreenSizeDetector";
import HeaderOptions from "../../config/HeaderLinks";
import cx from "classnames";

const baseUrl = "../../../../assets/images/svg/";
const Header = createClass({
  displayName: "Header",
  propTypes: {
    hideDownload: PropTypes.bool,
    logout: PropTypes.string,
    logoutCallback: PropTypes.func
  },
  getInitialState() {
    return {
      isSmall: false,
      isOpen: false
    };
  },
  resized(newSize) {
    this.setState({
      isSmall: newSize.isSmall
    });
  },
  componentWillMount() {
    let sc = new ScreenSize();
    sc.addListener(this.resized);
    this.setState({
      isSmall: sc.res.isSmall
    });
  },
  render() {
    return (
      <div
        className="Header"
        style={{ paddingBottom: this.state.isOpen ? 0 : null }}
      >
        {!this.state.isSmall && (
          <div className="Section-right">
            <a href="/">
              <div className="Logo">
                <img src="/assets/images/logo/logo.png" alt="اسنپ" />
              </div>
            </a>
            <div className="Options">
              <ul>
                {HeaderOptions.map((item, index) => {
                  return (
                    <li className={item.className} key={index}>
                      <a href={item.link} target={item.target}>
                        {item.title}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
        {this.state.isSmall && (
          <div className="Section-right">
            <div
              className={cx("Menu-Button", this.state.isOpen && "cross")}
              onClick={this.openMenu}
            >
              {this.state.isOpen ? (
                <div>
                  <img
                    src={`${baseUrl}close.svg`}
                    className="Menu-button cross"
                  />
                </div>
              ) : (
                <div className="section">
                  <div className="HLine" />
                  <div className="HLine" />
                  <div className="HLine" />
                </div>
              )}
            </div>
            <a href="/">
              <div className="Logo">
                <img src="/assets/images/logo/logo.png" alt="اسنپ" />
              </div>
            </a>
          </div>
        )}
        {!this.props.hideDownload && !this.props.logout && <DownloadButton />}
        {this.props.logout && (
          <div className="DownloadButton" onClick={this.props.logoutCallback}>
            <i className="icon icon-logout" />
            <div>خروج</div>
          </div>
        )}
        <div className={"Menu-Items" + (this.state.isOpen ? " Open-Menu" : "")}>
          <ul>
            {HeaderOptions.map((item, index) => {
              return (
                <li key={index}>
                  <span>
                    <a href={item.link} target={item.target}>
                      {item.title}
                    </a>
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  },
  openMenu() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
});

module.exports = Header;



// WEBPACK FOOTER //
// ./src/js/components/common/Header.react.js